module.exports = __webpack_public_path__ + "static/media/12_avatar.f36244c0.png";